import React from "react";
import SubscribePage from "../components/newsletter/SubscribePage";
import PageProps from "./partners";

export default function Page() {
  return <SubscribePage />;
}
Page.getInitialProps = async (): PageProps<{}> => {
  return {};
};
